import { Button as BaseButton } from 'antd'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

import { LeftArrowIcon as BaseLeftArrowIcon } from 'assets/icons'
import { usePermissions } from 'hooks'

const Button = styled(BaseButton)`
  background-color: ${({ theme }) => theme.colors.grey2};
  color: ${({ theme }) => theme.colors.olive5};
  height: 48px;
  width: 190px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 500;
  &:hover {
    background-color: ${({ theme }) => theme.colors.grey2} !important;
    color: ${({ theme }) => theme.colors.olive5} !important;
    border-color: ${({ theme }) => theme.colors.grey2} !important;
  }
`

const LeftArrowIcon = styled(BaseLeftArrowIcon)`
  font-size: 20px;
  position: absolute;
  left: 15px;
  top: 20px;
`

export const GoBackButton = () => {
  const navigate = useNavigate()
  const { t } = useTranslation('lot-dashboard')
  const { permissions } = usePermissions()

  return (
    <Button icon={<LeftArrowIcon width={4} height={8} />} onClick={() => navigate('/dashboard')}>
      {permissions.fieldEntity ? t('goBackButtonText') : t('goBackButtonTextFieldFlagOff')}
    </Button>
  )
}
